import React from 'react';
import { Layout } from 'antd';
import { Header } from 'components/Layout/Header';
import cn from 'components/Layout/BaseLayout/styles.module.scss';

const { Content } = Layout;

const BaseLayout = ({ children }) => {
  return (
    <Layout tagName="section" className={cn.layout}>
      <Header />
      <div className={cn.content}>
        <Content>
          {children}
        </Content>
      </div>
    </Layout>
  )
};

export default BaseLayout;
